module.exports = __webpack_public_path__ + "mont2.png?d999a83e9a635501daa61f756f646557";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mont2.png
// module id = 264
// module chunks = 0